<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  metaInfo() {
    return {
      title: this.title,
      meta: [{
        name: this.name,
        content: this.content
      }]
    }
  },
  data() {
    return {
      title: "",
      name: "",
      content: ""
    }
  },
  mounted() {
    this.loadData();
    if (Number(window.innerWidth) <= 1000) {
      console.log(">>>>>>>");
      this.$e.$emit("smallWindow")
    } else {
      this.$e.$emit("bigWindow")
    }
    window.onresize = () => {
      if (Number(window.innerWidth) <= 1000) {
        console.log(">>>>>>>");
        this.$e.$emit("smallWindow")
      } else {
        this.$e.$emit("bigWindow")
      }
    };
  },
  methods: {
    /**
     * 数据加载
     */
    loadData() {
      this.$axios.post(this.$url.companyInfo)
        .then(res => {
          console.log(res.data);
          let { error_code, companyInfo } = res.data;
          if (error_code == 2001) {
            this.title = companyInfo.title;
            this.name = companyInfo.keywords;
            this.content = companyInfo.description
          }
        });
    },
  }
}
</script>

<style>
@import "//at.alicdn.com/t/font_1909486_fv9nzih8b9.css";

* {
  margin: 0;
  padding: 0;
  list-style: none;
}

[class^="zyjm-"],
[class*="zyjm-"] {
  font-family: "iconfont" !important;
  font-size: 32px;
  font-style: normal;
  font-weight: 500;
  font-variant: normal;
  text-transform: none;
  line-height: 1;
  vertical-align: baseline;
  display: inline-block;
  -webkit-font-smoothing: antialiased;
}
body,
html {
  font-size: 100px;
  /* min-width: 1320px; */
  /* font-family: SIYUAN !important; */
  font-family: "Arial", "Source Han Sans CN", Helvetica;
}
p {
  margin-bottom: 0.16rem !important;
}

@media (max-width: 1440px) {
  body,
  html {
    font-size: 90px;
  }
}

a {
  text-decoration: none !important;
  color: #111 !important;
}
/* 
@font-face {
  font-family: "SiYUAN";
  src: url("../utils/SourceHanSansCN-Normal.otf") format("otf");
  font-weight: normal;
  font-style: normal;
} */
</style>



// WEBPACK FOOTER //
// src/App.vue